<template>
  <div class="ali-oss">
    <template v-if="bigImage">
      <el-carousel :autoplay="false" height="400px" arrow="always" :initial-index="dialog.index">
        <el-carousel-item v-for="file in previewFiles" :key="file.uid">
          <div class="oss-carousel-box">
            <el-image :src="previewUrl(file)" v-if="isImage(file)"></el-image>
            <ybl-pdf :src="previewUrl(file)" v-else :id="`carouse_item_${file.uid}`" :key="`pdf_${file.uid}`"></ybl-pdf>
          </div>
        </el-carousel-item>
      </el-carousel>
    </template>
    <template v-else>
      <el-upload v-bind="$attrs" action="" :auto-upload="false" :file-list="files" v-on="$listeners" v-if="listType!=='view'"
      :on-change="fileChange" :before-remove="beforeRemove">
        <slot></slot>
      </el-upload>
      <slot name="tip"></slot>
      <template v-if="preview">
        <ul class="el-upload-list el-upload-list--picture-card ali-oss__preview">
          <div v-for="(file, index) in fileList" :key="file.uid">
            <li class="el-upload-list__item is-ready">
              <img class="el-upload-list__item-thumbnail" :src="previewUrl(file)" alt="" v-if="isImage(file)" />
              <div class="el-upload-list__item-thumbnail ali-oss__ext" v-else-if="isPdf(file)">
                <img src="https://openapi.youbaolian.cn/pic/0/14/4fa894538a3e41b3a5a8cd28cbddfceb.jpeg" class="image_icon">
              </div>
              <div class="el-upload-list__item-thumbnail ali-oss__ext" v-else>{{file.ext || fileExt(file)}}</div>
              <span class="el-upload-list__item-actions">
                <span v-if="canPreview(file)" class="el-upload-list__item-preview" @click="handlePreview(file,index)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="canDownload(file)" class="el-upload-list__item-delete" @click="handleDownload(file,index)">
                  <i class="el-icon-download"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleRemove(file,index)" v-if="showDelete">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
              <el-progress v-show="file.status==='uploading'" :format="progressFormat" type="circle" :percentage="file.percentage" :width="100"></el-progress>
            </li>
            <div class="ali-oss__text">{{file.fileName || file.name}}</div>
          </div>
        </ul>
        <ybl-dialog :visible="dialog.visible" title="文件预览" @close="close" :showFooter="false" :append-to-body="true">
          <el-carousel :autoplay="false" height="600px" arrow="always" :initial-index="dialog.index">
            <el-carousel-item v-for="file in previewFiles" :key="file.uid">
              <div class="oss-carousel-box">
                <el-image :src="previewUrl(file)" v-if="isImage(file)"></el-image>
                <ybl-pdf :src="previewUrl(file)" v-else :id="`carouse_item_${file.uid}`" :key="`pdf_${file.uid}`"></ybl-pdf>
              </div>
            </el-carousel-item>
          </el-carousel>
        </ybl-dialog>
      </template>
    </template>
  </div>
</template>

<script>
import { tool } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'yblAliOss',
  modal: {
    props: 'aa',
    event: 'change'
  },
  props: {
    partnerId: { // 商户编码
      type: String | Number,
      required: false
    },
    module: { // 模块名称
      type: String,
      required: true
    },
    listType: { // 覆盖 el-upload的listType属性 ('view' 表示 查看)
      type: String,
      default: () => 'text'
    },
    preview: { // 自定义预览
      type: Boolean,
      default: () => false
    },
    idField: { // 需要过滤的字段名称（用于编辑 兼容历史数据）
      type: String,
      default: () => 'fileId'
    },
    bigImage: { // 显示大图预览（直接显示）
      type: Boolean,
      default: () => false
    },
    download: { // 是否启用下载功能
      type: Boolean,
      default: () => false
    },
    showDelete: { // 是否支持查看删除
      type: Boolean,
      default: () => true
    },
    files: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fileList: [],
      result: [],
      dialog: {
        visible: false,
        index: 0
      }
    }
  },
  created () {
    this.fileList = this.files || []
    console.log('fileList = ', this.fileList)
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER'
    ]),
    userInfo () {
      return this.CUSTOMER_LOGINCUSTOMER.data
    },
    currentPartnerId () {
      return this.partnerId || (this.userInfo && this.userInfo.PartnerId) || ''
    },
    previewFiles () {
      return (this.fileList || []).filter(file => this.canPreview(file))
    },
    initFileList () {
      return this.$attrs.value || this.$attrs['file-list'] || this.$attrs['fileList'] || []
    },
    fileExt () {
      return (file) => (file.fileName || file.name).trim().substring((file.fileName || file.name).trim().lastIndexOf('.') + 1)
    }
  },
  methods: {
    progressFormat (percentage) {
      return `${parseInt(percentage)}%`
    },
    isImage (file) {
      return `${file.fileType}`.indexOf('image/') === 0 || `${file.fileType}` === '0' // 兼容老版本的上传文件
    },
    isPdf (file) {
      return ['application/pdf', '3'].includes(`${file.fileType}`) || (file.raw && file.raw.type === 'application/pdf')
    },
    canPreview (file) {
      return this.isImage(file) || this.isPdf(file)
    },
    canDownload (file) {
      return this.download || (file.fileId && !this.canPreview(file))
    },
    previewUrl (file) {
      let url = file.fileUrl || ''
      if (!url && file.fileKey) {
        file.isLoadingUrl = true
        this.downLoadFileUrl(file).then(res => {
          file.fileUrl = res.url || ''
          file.isLoadingUrl = false
        }).catch(() => {
          file.isLoadingUrl = false
        })
      }
      return url
    },
    open () {
      this.dialog.visible = true
    },
    close () {
      this.dialog.visible = false
    },
    fileChange (file, fileList) {
      // console.log('e = ', file, fileList)
      const _this = this
      const beforeUpload = this.$attrs['before-upload'] || this.$attrs['beforeUpload']
      if (beforeUpload && !beforeUpload(file.raw)) {
        this.beforeRemove(file, fileList)
        return
      }
      const fileType = file.raw.type
      const ext = file.name.substring(file.name.lastIndexOf('.') + 1)
      const type = this.getFileTypeValue(fileType, ext)
      if (this.preview && (['png', 'jpg', 'jpeg', 'bmp', 'pdf'].includes(ext) || fileType.includes('image/'))) {
        tool.getFileBase64(file.raw, info => {
          const item = [{...file, fileType: type, fileUrl: info.target.result, ext: ext}]
          _this.fileList = [..._this.fileList, ...item]
        })
      } else {
        this.fileList.push({...file, fileType: type, fileUrl: '', ext: ext})
      }
      console.log('>>>>>>>>>>>>>>>>>>>>', this.fileList)
      const autoUpload = this.$attrs['auto-upload'] || this.$attrs['autoUpload']
      if (autoUpload) {
        const name = `${this.currentPartnerId}/${this.module}/${Math.random()}_${file.name}`
        this.uploadFile(name, file).then(data => {
          file.fileKey = name
          file.fileName = file.name
          file.fileType = type
          this.$emit('change', file, fileList)
        })
      } else {
        this.$emit('change', file, fileList)
      }
    },
    uploadFile (name, file) {
      let formData = new FormData()
      formData.append('file', file.raw)
      return this.$store.dispatch('fileOssUploadV2', { params: { fileKey: name }, data: formData }).then(res => {
        file.abortCheckpoint = file.raw
        file.percentage = 0
        file.status = 'ready'
      })
    },
    getFileExtByFileName (file) {
      const name = file.name || file.fileName
      return name.substring(name.lastIndexOf('.') + 1).toLowerCase()
    },
    getFileTypeValue (fileType, extension, file = null) { // 0：图片，1：Excel，2：WORD文件，3：PDF文件'
      const ext = (extension || this.getFileExtByFileName(file)).toLowerCase()
      console.log('fileType = ', fileType, ext)
      const imageExt = ['png', 'jpg', 'jpeg', 'bmp', 'gif'].includes(ext)

      return (`${fileType}`.includes('image/') || `${fileType}` === '0' || imageExt) ? '0' : (ext === 'pdf' ? '3' : (['doc', 'docx'].includes(ext) ? '2' : (['xls', 'xlsx'].includes(ext) ? '1' : '99')))
    },
    beforeRemove (file, fileList) {
      // console.log('=========beforeRemove=============', file, fileList)
      const item = this.fileList.find(item => item.uid === file.uid)
      // console.log('item = ', item, this.fileList)
      if (item) {
        const index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
      }
      if (file.raw && fileList) { // 用于处理列表显示时，传入非法格式文件的处理（列表显示）
        const _index = fileList.length
        fileList.splice(_index - 1, 1)
      }
      this.$emit('change', file, fileList)
    },
    async multiPartUpload () {
      const _this = this
      const idField = this.idField
      const alreadyUpload = (this.fileList || []).filter(item => item.fileKey || item[idField])
      console.log('this.fileList = ', this.fileList)
      const result = await Promise.all(
        (_this.fileList || []).filter(item => !item.fileKey && !item[idField]).map(file => {
          const name = `${this.currentPartnerId}/${this.module}/${Math.random()}_${file.name}`
          return _this.uploadFile(name, file).then(data => {
            file.status = 0
            return {
              ...file,
              fileKey: name,
              fileName: file.name,
              fileType: file.fileType, // _this.getFileTypeValue(file.fileType, file.ext),
              fileUrl: '', //  上传成功后清空本地base存储
              status: 0
            }
          })
        })
      )
      this.fileList = [...alreadyUpload, ...result].map(item => ({
        [idField]: item[idField],
        fileKey: item.fileKey,
        fileName: item.fileName,
        fileType: _this.getFileTypeValue(item.fileType, item.ext, item),
        fileUrl: item.fileUrl,
        status: 0
      }))

      return this.fileList
    },
    submit () {
      console.log('this.submit = ', this.fileList)
      return this.multiPartUpload().then(data => {
        return data
      })
    },
    downLoadFileUrl (file) {
      file.status = file.status === 'success' ? 0 : file.status
      if (!file.fileKey) return ''

      return this.$store.dispatch('fileGeneratePresignUrl', { params: { fileKey: file.fileKey } })
    },
    handlePreview (file, index) {
      this.dialog.index = index
      this.open()
    },
    async handleDownload (file, index) {
      if (file.fileUrl) {
        tool.downLoadUrlFile(file.fileUrl, file.fileName)
      } else {
        const res = await this.downLoadFileUrl(file)
        const url = res.url || ''
        url && tool.downLoadUrlFile(url, file.fileName)
      }
    },
    handleRemove (file, index) {
      this.beforeRemove(file, null)
      // this.fileList.splice(index, 1)
    }
  },
  watch: {
    'files': function (newVal, oldVal) {
      console.log('newVal = ', newVal, oldVal)
      this.fileList = [...newVal]
      /* this.fileList = newVal.map(item => ({
        ...item,
        status: 0
      })) */
    }
  }
}
</script>

<style lang="less" scoped>
.ali-oss{
  .carousel-box{
    height: 400px;
    overflow: auto;
  }
  &__preview{
    display:flex;
    padding-top: 8px;
    flex-wrap: wrap;
    .el-upload-list__item{
      width: 220px-20px;
      height: 120px;
      margin: 0 8px 0 0;
    }
  }
  &__text{
    text-align: center;
    overflow: hidden;
    width: 220px-20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__ext{
    position: absolute;
    width:40px;
    top: 50%;
    height: 40px;
    left: 50%;
    text-align: center;
    transform: translate(-20px, -20px);
    font-size: 20px;
    word-break: normal;
    .image_icon{
      width: 30px;
    }
  }
}
.oss-carousel-box{
  height: 600px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/aliOSS.vue